module.exports = __webpack_public_path__ + "static/media/skyway_helps_1.c93135c4.jpg";